module.exports = __webpack_public_path__ + "6a1e86e0d113544288f3cbbb16fe073b.svg";